import { render, staticRenderFns } from "./Adminpay24DepositDetails.vue?vue&type=template&id=4ab9b7ad&scoped=true&"
import script from "./Adminpay24DepositDetails.vue?vue&type=script&lang=js&"
export * from "./Adminpay24DepositDetails.vue?vue&type=script&lang=js&"
import style0 from "./Adminpay24DepositDetails.vue?vue&type=style&index=0&id=4ab9b7ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9b7ad",
  null
  
)

export default component.exports